import * as cheerio from 'cheerio';
import { slugify } from './slugify.lib';

export const transformHtml = (html: string) => {
  const $ = cheerio.load(html);

  $('h2, h3').each((i, el) => {
    $(el).attr('id', slugify($(el).text()));
  });

  return $.html();
};
